module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nif(config.headlineKey){\n%><h1><%= storage.__(config.headlineKey) %></h1><%\n}\n%>\n<ol>\n<%\nfor(var orderData of model.historyEntries){\nvar order = orderData.attributes || {};\n%><li><%= utils.moment(order.updatedAt).format('DD.MM.YYYY HH:mm') %> - <%= (model.stateMapping || {})[order.state] || order.state %></li><%\n}\n%>\n</ol>\n</div>"
  , __filename = "components/templates/ttgShop/orders/history/history.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
if(config.headlineKey){

    ; __line = 4
    ; __append("<h1>")
    ; __append(escapeFn( storage.__(config.headlineKey) ))
    ; __append("</h1>")
    ; 
}

    ; __line = 6
    ; __append("\n<ol>\n")
    ; __line = 8
    ; 
for(var orderData of model.historyEntries){
var order = orderData.attributes || {};

    ; __line = 11
    ; __append("<li>")
    ; __append(escapeFn( utils.moment(order.updatedAt).format('DD.MM.YYYY HH:mm') ))
    ; __append(" - ")
    ; __append(escapeFn( (model.stateMapping || {})[order.state] || order.state ))
    ; __append("</li>")
    ; 
}

    ; __line = 13
    ; __append("\n</ol>\n</div>")
    ; __line = 15
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/ttgShop/orders/history/history.ejs

}